import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_TENANCY_CONTRACTS:
      return { ..._.mapKeys(action.payload, "Id") };
    // return { ...state, ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_TENANCY_CONTRACT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_TENANCY_CONTRACT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_TENANCY_CONTRACT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_TENANCY_CONTRACT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
